import React from 'react';

class ModalFormChoice extends React.Component {
	constructor(props) {
		super(props);
	}

    render() {
        const formBox = {
            border: '1px dashed #AEB0B5',
            padding: '12px 20px 12px 20px',
            margin: '20px 0',
            display: 'flex',
            flexDirection: 'row',
            color: '#5B616B',
            fontSize: '13px'
		}
		
		const formName = {
            fontWeight: 'bold',
			margin: '0',
			fontSize: '13px'
        }


		const formNameGov = {
			fontStyle: 'italic',
			margin: '0',
			fontSize: '13px',
			color: '#5B616B',
			fontWeight: 'bold',
			lineHeight: '17px'
		};

		const sectionList = {
			width: '40%',
			fontSize: '13px',
			color: '#5B616B',
			lineHeight: '17px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center'
		};

		const sectionListItems = {
			fontSize: '13px',
			color: '#5B616B',
			margin: '0',
			alignSelf: 'flex-end'
		};

		const formInfo = {
			width: '60%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center'
		};

		let {
			formCommonName: form_label,
			formGovName: gov_label,
			sections,
			

		} = this.props;

		return (
			<div style={formBox}>
				<div style={formInfo}>
					<p style={formName}>{form_label}</p>
					<p style={formNameGov}>{gov_label}</p>
				</div>
				<div style={sectionList}>
					{sections.map((section, index) => {
						return (
							<p style={sectionListItems} key={index}>
								{section}
							</p>
						);
					})}
				</div>
			</div>
		);
	}
}

export default ModalFormChoice;
